import React from 'react';
import '../../styles/services.css';
import { motion } from 'framer-motion';

const Consulting = () => (
  <motion.div
    className="services-container"
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
  >
    <h1 className="services-title">IT Consulting & Strategy</h1>
    <p className="services-subtitle">
      Expert advisory services to align IT strategy with business goals, driving transformation.
    </p>

    <div className="services-grid">
      <div className="service-card">
        <h2>📊 Strategic Roadmapping</h2>
        <p>Plan and align your IT initiatives with long-term business objectives.</p>
      </div>
      <div className="service-card">
        <h2>🔍 Technology Audits</h2>
        <p>Identify inefficiencies and optimize tech operations through expert analysis.</p>
      </div>
      <div className="service-card">
        <h2>🤝 Vendor Evaluation</h2>
        <p>Choose the best tools and platforms that suit your needs and scale.</p>
      </div>
    </div>
  </motion.div>
);

export default Consulting;
